var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWave = function SvgWave(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 21.5,
    y1: 54.757809,
    x2: 21.5,
    y2: 118.258057,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(40.392157%,93.725491%,92.54902%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 21.5,
    y1: 24.859381,
    x2: 21.5,
    y2: 141.163635,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 43,
    y1: 24.859381,
    x2: 43,
    y2: 141.163635,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 64.5,
    y1: 24.859381,
    x2: 64.5,
    y2: 141.163635,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 54.757809,
    x2: 86,
    y2: 118.258057,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(40.392157%,93.725491%,92.54902%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 24.859381,
    x2: 86,
    y2: 141.163635,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 107.5,
    y1: 24.859381,
    x2: 107.5,
    y2: 141.163635,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 129,
    y1: 24.859381,
    x2: 129,
    y2: 141.163635,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 150.5,
    y1: 54.757809,
    x2: 150.5,
    y2: 118.258057,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(40.392157%,93.725491%,92.54902%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear9",
    gradientUnits: "userSpaceOnUse",
    x1: 150.5,
    y1: 24.859381,
    x2: 150.5,
    y2: 141.163635,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface3148489"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 7.8125 28.125 C 7.8125 28.554688 7.460938 28.90625 7.03125 28.90625 L 5.46875 28.90625 C 5.039062 28.90625 4.6875 28.554688 4.6875 28.125 L 4.6875 21.875 C 4.6875 21.445312 5.039062 21.09375 5.46875 21.09375 L 7.03125 21.09375 C 7.460938 21.09375 7.8125 21.445312 7.8125 21.875 Z M 7.8125 28.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 7.03125 29.6875 L 5.46875 29.6875 C 4.605469 29.6875 3.90625 28.988281 3.90625 28.125 L 3.90625 21.875 C 3.90625 21.011719 4.605469 20.3125 5.46875 20.3125 L 7.03125 20.3125 C 7.894531 20.3125 8.59375 21.011719 8.59375 21.875 L 8.59375 28.125 C 8.59375 28.988281 7.894531 29.6875 7.03125 29.6875 Z M 5.46875 21.875 L 5.46875 28.125 L 7.03125 28.125 L 7.03125 21.875 Z M 5.46875 21.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 13.28125 34.375 L 11.71875 34.375 C 10.855469 34.375 10.15625 33.675781 10.15625 32.8125 L 10.15625 17.1875 C 10.15625 16.324219 10.855469 15.625 11.71875 15.625 L 13.28125 15.625 C 14.144531 15.625 14.84375 16.324219 14.84375 17.1875 L 14.84375 32.8125 C 14.84375 33.675781 14.144531 34.375 13.28125 34.375 Z M 11.71875 17.1875 L 11.71875 32.8125 L 13.28125 32.8125 L 13.28125 17.1875 Z M 11.71875 17.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 19.53125 40.625 L 17.96875 40.625 C 17.105469 40.625 16.40625 39.925781 16.40625 39.0625 L 16.40625 10.9375 C 16.40625 10.074219 17.105469 9.375 17.96875 9.375 L 19.53125 9.375 C 20.394531 9.375 21.09375 10.074219 21.09375 10.9375 L 21.09375 39.0625 C 21.09375 39.925781 20.394531 40.625 19.53125 40.625 Z M 17.96875 10.9375 L 17.96875 39.0625 L 19.53125 39.0625 L 19.53125 10.9375 Z M 17.96875 10.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 26.5625 32.8125 C 26.5625 33.242188 26.210938 33.59375 25.78125 33.59375 L 24.21875 33.59375 C 23.789062 33.59375 23.4375 33.242188 23.4375 32.8125 L 23.4375 17.1875 C 23.4375 16.757812 23.789062 16.40625 24.21875 16.40625 L 25.78125 16.40625 C 26.210938 16.40625 26.5625 16.757812 26.5625 17.1875 Z M 26.5625 32.8125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 25.78125 34.375 L 24.21875 34.375 C 23.355469 34.375 22.65625 33.675781 22.65625 32.8125 L 22.65625 17.1875 C 22.65625 16.324219 23.355469 15.625 24.21875 15.625 L 25.78125 15.625 C 26.644531 15.625 27.34375 16.324219 27.34375 17.1875 L 27.34375 32.8125 C 27.34375 33.675781 26.644531 34.375 25.78125 34.375 Z M 24.21875 17.1875 L 24.21875 32.8125 L 25.78125 32.8125 L 25.78125 17.1875 Z M 24.21875 17.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 32.03125 40.625 L 30.46875 40.625 C 29.605469 40.625 28.90625 39.925781 28.90625 39.0625 L 28.90625 10.9375 C 28.90625 10.074219 29.605469 9.375 30.46875 9.375 L 32.03125 9.375 C 32.894531 9.375 33.59375 10.074219 33.59375 10.9375 L 33.59375 39.0625 C 33.59375 39.925781 32.894531 40.625 32.03125 40.625 Z M 30.46875 10.9375 L 30.46875 39.0625 L 32.03125 39.0625 L 32.03125 10.9375 Z M 30.46875 10.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 38.28125 34.375 L 36.71875 34.375 C 35.855469 34.375 35.15625 33.675781 35.15625 32.8125 L 35.15625 17.1875 C 35.15625 16.324219 35.855469 15.625 36.71875 15.625 L 38.28125 15.625 C 39.144531 15.625 39.84375 16.324219 39.84375 17.1875 L 39.84375 32.8125 C 39.84375 33.675781 39.144531 34.375 38.28125 34.375 Z M 36.71875 17.1875 L 36.71875 32.8125 L 38.28125 32.8125 L 38.28125 17.1875 Z M 36.71875 17.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear8)"
    },
    d: "M 45.3125 28.125 C 45.3125 28.554688 44.960938 28.90625 44.53125 28.90625 L 42.96875 28.90625 C 42.539062 28.90625 42.1875 28.554688 42.1875 28.125 L 42.1875 21.875 C 42.1875 21.445312 42.539062 21.09375 42.96875 21.09375 L 44.53125 21.09375 C 44.960938 21.09375 45.3125 21.445312 45.3125 21.875 Z M 45.3125 28.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear9)"
    },
    d: "M 44.53125 29.6875 L 42.96875 29.6875 C 42.105469 29.6875 41.40625 28.988281 41.40625 28.125 L 41.40625 21.875 C 41.40625 21.011719 42.105469 20.3125 42.96875 20.3125 L 44.53125 20.3125 C 45.394531 20.3125 46.09375 21.011719 46.09375 21.875 L 46.09375 28.125 C 46.09375 28.988281 45.394531 29.6875 44.53125 29.6875 Z M 42.96875 21.875 L 42.96875 28.125 L 44.53125 28.125 L 44.53125 21.875 Z M 42.96875 21.875 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wave.045f3559.svg";
export { ForwardRef as ReactComponent };